'use strict';

(function() {
	angular.module('onboarding.broker.contracts')
		.directive('cobBrokerContract', cobBrokerContract);

	cobBrokerContract.$inject = [
		'subjectObserverMessagesService', 'observerService', 'contractService', 'Upload', 'sessionService', '$state',
		'$stateParams'
	];

	var observerService,
		subjectObserverMessagesService,
		subjectMessages,
		observerMessages,
		contractService,
		ngFileUpload,
		sessionService,
		$state,
		$stateParams;

	function cobBrokerContract(_subjectObserverMessagesService_,
		_observerService_,
		_contractService_,
		_ngFileUpload_,
		_sessionService_,
		_state_,
		_$stateParams_) {
		subjectObserverMessagesService = _subjectObserverMessagesService_;
		contractService = _contractService_;

		sessionService = _sessionService_;
		$state = _state_;
		$stateParams = _$stateParams_;
		observerService = _observerService_;
		subjectObserverMessagesService = _subjectObserverMessagesService_;

		ngFileUpload = _ngFileUpload_;

		return {
			restrict: 'E',
			scope: {
				contracts: '=',
				contract: '=',
				//disableUpload: '='
			},
			templateUrl: '/app/broker/contracts/brokerContract.html',
			link: linkFunction
		};
	}


	function linkFunction(scope) {

		activate();

		function activate() {
			if (sessionService.isAuthorizedInternalAdmin() && !$stateParams.brokerId) {
				$state.go('brokersAdmin');

				return;
			}

			subjectMessages = subjectObserverMessagesService.getSubjectMessages();
			observerMessages = subjectObserverMessagesService.getObserverMessages();

			scope.upload = fileSelect;

			if (!scope.contract) {
				scope.contract = {};
			}
			if (!scope.contract.errors) {
				scope.contract.errors = {};
			}

			scope.contract.save = saveContract;
			scope.contract.validate = validate;
			scope.contract.validateContractName = validateContractName;
			scope.contract.reset = reset;
			scope.contract.isready = true;
			scope.disableUpload = false;
		}

		function saveContract() {
			if (validate() === false) {
				return;
			}

			var regex = /(?:\.([^.]+))?$/;

			var addBrokerContractRequest = {
				name: scope.contract.contractName,
				description: scope.contract.contractDescription,
				fileContent: scope.contract.contractFile.base64,
				mimeType: scope.contract.contractFile.filetype,
				fileName: scope.contract.contractFile.filename,
				fileSize: scope.contract.contractFile.filesize,
				fileExtension: regex.exec(scope.contract.contractFile.filename)[1],
				contractId: scope.contract.contractId
			};

			setTimeout(function () {
				observerService.sendMessageToSubject(scope, subjectObserverMessagesService.getSubjectMessages().COB_SUBJECT_AJAX_WAITING);
			}, 1);

			contractService.addContract(addBrokerContractRequest)
				.then(function() {
					observerService.sendMessageToSubject(scope,
						subjectObserverMessagesService.getSubjectMessages().COB_SUBJECT_FILE_UPLOAD_SAVED);
					reset();
				})
				.catch(function(res) {
					var modelErrors = res.data.modelState;
					var errors = [];
					for (var key in modelErrors) {
						for (var i = 0; i < modelErrors[key].length; i++) {
							errors.push(modelErrors[key][i]);
						}
					}
				}).finally(function () {
					observerService
						.sendMessageToSubject(scope, subjectObserverMessagesService.getSubjectMessages().COB_SUBJECT_AJAX_DONE);
				});
		}

		function validateContractName() {
			if (scope.contract.contractName) {
				if (scope.contract.contractId) {
					delete scope.contract.errors['contractName'];
				} else {
					if (scope.contracts) {
						delete scope.contract.errors['contractName'];
						for (var i = 0; i < scope.contracts.length; i++) {
							if (scope.contract.contractName.toLowerCase() === scope.contracts[i].name.toLowerCase()) {
								scope.contract.errors.contractName = true;
								break;
							}
						}
					} else {
						scope.contract.errors.contractName = true;
					}
				}
			} else {
				scope.contract.errors.contractName = true;
			}

			if (scope.contract.contractFile.filename) {
				scope.contract.isValid = !(Object.keys(scope.contract.errors).length);
			}
		}

		function validateFile() {
			var errors = [];
			var validMimeTypes = [
				'application/pdf', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
				'application/msword', 'application/vnd.ms-word', 'image/tiff', 'image/png', 'image/jpeg'
			];

			var validFileExtensions = ['pdf', 'docx', 'doc', 'tif', 'tiff', 'png', 'jpg', 'jpeg'];


			if (scope.contract.contractFile.filesize >= 10485760) {
				errors.push('File size must be less than 10mb');
			}


			if (scope.contract.contractFile.filetype !== '') {
				if (validMimeTypes.indexOf(scope.contract.contractFile.filetype) === -1) {
					errors.push('Select a valid file type');
				}
			} else {
				var regex = /(?:\.([^.]+))?$/;
				var extension = regex.exec(scope.contract.contractFile.filename);

				if (validFileExtensions.indexOf(extension[1]) === -1) {
					errors.push('Select a valid file type');
				} else {
					switch (extension[1]) {
					case 'pdf':
						scope.contract.contractFile.filetype = 'application/pdf';
						break;
					case 'docx':
						scope.contract.contractFile
							.filetype = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
						break;
					case 'doc':
						scope.contract.contractFile.filetype = 'application/msword';
						break;
					case 'tiff':
					case 'tif':
						scope.contract.contractFile.filetype = 'image/tiff';
						break;
					case 'png':
						scope.contract.contractFile.filetype = 'image/png';
						break;
					case 'jpg':
					case 'jpeg':
						scope.contract.contractFile.filetype = 'image/jpeg';
						break;
					}
				}
			}

			if (errors.length > 0) {
				scope.contract.errors.file = true;
			} else {
				delete scope.contract.errors['file'];
			}

			if (scope.contract.contractName) {
				scope.contract.isValid = !(Object.keys(scope.contract.errors).length);
			}
		}

		function fileSelect(files) {
			if (files && files.length == 1) {
				var file = files[0];

				if (!scope.contract.contractFile) {
					scope.contract.contractFile = {};
				}
				scope.contract.contractFile.filetype = file.type;
				scope.contractFile.filename = file.name;
				scope.contract.contractFile.filename = file.name;
				scope.contract.contractFile.filesize = file.size;

				ngFileUpload.base64DataUrl(file, false)
					.then(function(url) {
						scope.contract.contractFile.base64 = url.split(',')[1];
						validateFile();
						if (scope.contract.errors.file) {
							observerService
								.sendMessageToSubject(scope,
									subjectObserverMessagesService.getSubjectMessages().COB_SUBJECT_FILE_UPLOAD_ERROR);
						} else {
							scope.disableUpload = true;
							observerService
								.sendMessageToSubject(scope,
									subjectObserverMessagesService
										.getSubjectMessages()
										.COB_SUBJECT_FILE_UPLOAD_SUCCESS);
						}
					});
			} else {
				observerService.sendMessageToSubject(scope,
					subjectObserverMessagesService.getSubjectMessages().COB_SUBJECT_FILE_UPLOAD_ERROR);
			}
		}

		function validate() {
			validateContractName();
			validateFile();
			scope.contract.isValid = !(Object.keys(scope.contract.errors).length);

			return scope.contract.isValid;
		}

		function reset() {
			scope.disableUpload = false;
			scope.contract.isValid = false;
			scope.contract.contractFile = {};
			scope.contract.errors = {};
			scope.contract.contractDescription = '';
			if (!scope.contract.contractId) {
				scope.contract.contractName = '';
			}

		}

		function registerObserverHandlers() {
			observerService.registerHandlers(scope,
				[
					{ message: observerMessages.COB_OBSERVER_FILE_UPLOAD_SUCCESS, handler: onSuccess },
					{ message: observerMessages.COB_OBSERVER_FILE_UPLOAD_SAVED, handler: onChange },
					{ message: observerMessages.COB_OBSERVER_FILE_UPLOAD_ERROR, handler: onError }
				]);
		}

		function onSuccess() {
			console.log('File Upload Success');
		}

		function onChange() {
			console.log('File Upload Change');
		}

		function onError() {
			console.log('File Upload Error');
		}
	}

})();
